import React from 'react';
import { Link } from 'react-router-dom';

import MarkdownContent from '../components/common/MarkdownContent';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { legalPage } from '../config/legal';

/**
 * /consumer-health-data — keepr's Consumer Health Data Privacy Policy
 * (KPR-478, the owner's ruling p03), public and signed out, linked from the
 * health-package consent step, the signed-out footer and the privacy policy.
 *
 * Outside the app shell (PublicShell), like /email-preferences: a person
 * opens it from the consent step in a new tab, or signed out from the
 * homepage, and the shell's signed-in reads have no business around a legal
 * page.
 *
 * Until the legal pages publish (src/config/legal.js — the Oregon LLC, then
 * counsel), the page says only that the policy is being reviewed and is not
 * published yet: no draft words, and no promise a lawyer has not read. The
 * consent step itself states what keepr holds and commits to; this page will
 * carry the full policy.
 */
export default function ConsumerHealthData() {
	const page = legalPage('consumer-health-data');
	useDocumentTitle(page.title);

	return (
		<article className="legal-page">
			<h1>{page.title}</h1>
			{page.markdown ? (
				<MarkdownContent markdown={page.markdown} className="legal-page__body" />
			) : (
				<div className="legal-page__body">
					<p>
						keepr&apos;s consumer health data policy will be published here: what health information
						keepr keeps, why, who handles it, and how to see, export or delete it.
					</p>
					<p>It is being reviewed and isn&apos;t published yet.</p>
					<p>
						When you add a health package from Discover, keepr asks for your consent first and says
						what it keeps.
					</p>
					<p><Link to="/">Go to keepr</Link></p>
				</div>
			)}
		</article>
	);
}
